import { gql } from '../services/api'
import { faSeedling, faBolt, faLeaf, faFire, faSun, faStar, faMeteor, faGem, faCrown, faShield, faShieldAlt } from '@fortawesome/free-solid-svg-icons';

import { useMediaQuery } from 'react-responsive';

interface Point {
    max: number;
    level: number;
}

interface ContributionData {
    [date: string]: {
      level: number;
      data?: Record<string, unknown>;
    };
}

export interface ModuleItem {
    title: string;
    status: 'in_progress' | 'complete' | 'unavailable';
    link: string;
    label: any;
    available: boolean;
}

export interface Chapter {
    chapter: string;
    status: 'complete' | 'in_progress' | 'unavailable';
    label: string; 
    available: boolean;
    description: string;
    modules: ModuleItem[];
}

export interface Phishing {
    correct_attempts: number;
    failed_attempts: number;
    total_attemps: number;
}

type Activity = {
    content: string;
    date: string;
    indicator: string;
    points: number | false;
};
  
type MonthData = Activity[];
type YearlyData = {
    [month: number]: MonthData;
};
  
export type ActivityData = {
    [year: number]: YearlyData;
};

export type LatestMonthData = {
    year: number;
    month: number;
    activities: MonthData;
  } | null;


export type LatestMonthDataSingle = {
    year: number;
    month: number;
    activities: MonthData;
};

export type Organization = {
    name: string;
    shortname: string;
    date_created: string;
    id: number;
    owner: boolean;
    postal_code: string;
    website: string;
    user_count: number;
    address: string;
};

export type User = {
    uuid?: string;
    firstname: string;
    lastname: string;
    email: string;
    password: string | null;
    phone: string;
    country: string;
    address_street_city: string;
    postal_code: string;
    photo?: string | number | null; 
    job_title: string;
    role?: number;
    status?: number;
    organization_id?: number;
    exp?: number;
    level?: number;
    language?: string;
};

export type UserSimReport = {
    uuid?: string;
    firstname: string;
    lastname: string;
    reported_count: number;
    clicked_count: number;
    ignored_count: number;
    academy_chapters_completed: number;
    quizes_taken: number;
    questions_correct: number;
    questions_incorrect: number;
}


export type Organizations = Organization[]; 

export const smallBadge = 'sm-badge'
export const largeBadge = 'lg-badge'

export const authToken = 'auth-token'
export const uuidToken = 'uuid'
export const tokenUpdate = 'auth-update'
export const systemLanguage = 'language'
export const organization = 'organization'
export const organizations = 'organizations'
export const activeOrganization = 'organization-active'
export const organizationCount = 'organization-total'
export const userCount = 'user-total'

export const inProgress = 'in_progress'
export const unavailable = 'unavailable'
export const complete = 'complete'
export const locked = 'locked'

export const userLevel = 'user-level'
export const userPoints = 'user-points'
export const userFullName = 'user-fullname'
export const userContData = 'user-cont'
export const userChapters = 'user-chapters'
export const menuLabels = 'menu-labels'
export const systemLabels = 'system-labels'
export const menuOpen = 'menu-open'
export const userActivity = 'user-activity'
export const courseView = 'course-view'
export const userPhishing = 'user-phishing'
export const appVersion = 'app-version'

export const dashboardLabel = 'dashboard_label'
export const usersLabel = 'users_label'
export const organizationsLabel = 'organizations_label'
export const reportsLabel = 'reports_label'
export const academyLabel = 'academy_label'
export const settingsLabel = 'settings_label'
export const achievementsLabel = 'achievements_label'
export const activityLabel = 'activity_label'
export const loginLabel = 'login'
export const selectLanguageLabel = 'select_language'
export const selectOrganizationLabel = 'select_organization'
export const warningEmailsLabel = 'warning_emails'

export const chapterItemLabel = 'chapter_label'
export const websiteLabel = 'website_label'
export const usernameLabel = 'username_label'
export const passwordLabel = 'password_label'
export const createPasswordLabel = 'create_password_label'
export const setPasswordLabel = 'set_password_label'
export const onboardIntroText = 'onboarding_intro_text'
export const onboardInvalidText = 'onboarding_invalid_text'
export const onboardInvalidIntroText = 'onboarding_invalid_intro_text'
export const welcomeLabel = 'welcome_label'
export const welcomeIntroLabel = 'welcome_intro_label'
export const completedCoursesLabel = 'completed_courses_label'
export const completedOutOfLabel = 'completed_out_of_label'
export const goToAcademyLabel = 'go_to_academy_label'
export const viewYourAchievementsLabel = 'view_achievements_label'
export const viewAllLabel = 'view_all_label'
export const latestActivityLabel = 'latest_activity_label'
export const academyIntroTextDashboardLabel = 'academy_intro_text_dashboard_label'
export const simulationSummaryLabel = 'simulation_summary_label'
export const simulationSummaryIntroTextDashboardLabel = 'simulation_summary_intro_text_dashboard_label'
export const phishingAttemptsReportedLabel = 'phishing_attempts_reported_label'
export const phishingAttemptsFailedLabel = 'phishing_attempts_failed_label'
export const outOfLabel = 'out_of_label'
export const chapterTextLabel = 'chapter_text_label'
export const modulesCompletedLabel = 'modules_completed_label'
export const inProgressLabel = 'in_progress_label'
export const totalLabel = 'total_label'
export const continueLearningLabel = 'continue_learning_label'
export const signOutLabel = 'sign_out_label'
export const academyIntroTextLabel = 'academy_intro_text_label'
export const achievementsIntroTextLabel = 'achievements_intro_text_label'
export const badgesLabel = 'badges_label'
export const badgesIntroTextLabel = 'badges_intro_text_label'
export const badgesNoTextLabel = 'badges_no_text_label'
export const levelScoreLabel = 'level_score_label'
export const recentActivityLabel = 'recent_activity_label'
export const recentActivityIntroTextLabel = 'recent_activity_intro_text_label'
export const activeDaysLabel = 'active_days_label'
export const activityIntroTextLabel = 'activity_intro_text_label'
export const reportsIntroTextLabel = 'reports_intro_text_label'
export const latestActivityLogLabel = 'latest_activity_log_label'
export const activityLogLabel = 'activity_log_label'
export const noActivityAvailableForLabel = 'no_activity_available_for_label'
export const noActivityAvailableLabel = 'no_activity_available_label'
export const yetLabel = 'yet_label'
export const levelUpLabel = 'level_up_label'
export const levelLabel = 'level_label'
export const skipLabel = 'skip_label'
export const continueLabel = 'continue_label'
export const takeQuizLabel = 'take_quiz_label'
export const videoLabel = 'video_label'
export const nextQuestionLabel = 'next_question_label'
export const quizLabel = 'quiz_label'
export const questionLabel = 'question_label'
export const completeLabel = 'complete_label'
export const nextChapterLabel = 'next_chapter_label'
export const submitLabel = 'submit_label'
export const expPointsGainedLabel = 'exp_points_gained_label'
export const expPointsGainedCorrectAnswerLabel = 'exp_points_gained_correct_answer_label'
export const introLabel = 'intro_label'
export const confirmPasswordLabel = 'confirm_password_label'
export const passwordsMatchLabel = 'passwords_match_label'
export const incorrectUserOrPasswordLabel = 'incorrect_username_password_label'
export const falseEmailsTitleLabel = 'false_emails_title_label'
export const falseEmailsContentLabel = 'false_emails_content_label'
export const falseEmailsContentItemLabel = 'false_emails_content_item_label'
export const previousLabel = 'previous_label'
export const nextLabel = 'next_label'
 
export const urlGithubCallback = '/github/callback'
export const urlAll = '*'

export const urlHome = '/'
export const urlLogin = '/login'
export const urlSignUp = '/sign-up'
export const urlScore = '/score'
export const urlAcademy = '/academy'
export const urlActivity = '/activity'
export const urlFalseEmails = '/false-emails'
export const urlOnboard = '/onboarding'
export const urlArticle = '/article'
export const urlReports = '/reports'
export const urlUsers = '/users'
export const urlUser = '/user'
export const urlOrganizations = '/organizations'
export const urlOrganization = '/organization'
export const urlSettings = '/settings'

export const enUS = 'en-us' as const;
export const enLang = 'lang_en' as const;
export const en = 'EN' as const;

export const ruRU = 'ru-ru' as const;
export const ruLang = 'lang_ru' as const;
export const ru = 'RU' as const;

export const nlNL = 'nl-nl' as const;
export const nlLang = 'lang_nl' as const;
export const nl = 'NL' as const;

export const validLangs: string[] = [enLang,nlLang,ruLang]

export type LanguageCode = typeof enUS | typeof nlNL | typeof ruRU;

export const LANGUAGE_SHORTS = [en, nl, ru] as const;
export type LanguageShort = typeof LANGUAGE_SHORTS[number];

export interface Language {
  name: string;
  short: LanguageShort;
  flag: string;
}

export const languageParse = (language: string) => {
  switch(language) {
    case enLang: default: return enUS;
    case nlLang: return nlNL;
    case ruLang: return ruRU;
  }
}

export const allLanguages: Record<LanguageCode, Language> = {
    [enUS]: {
      name: "English",
      short: "EN",
      flag: "🇬🇧"
    },
    [nlNL]: {
        name: "Nederlands",
        short: "NL",
        flag: "🇳🇱"
    },
    [ruRU]: {
      name: "Русский",
      short: "RU",
      flag: "🇷🇺"
    }
};

const region = process.env.REACT_APP_REGION;

const filteredLanguages = Object.entries(allLanguages).filter(([code]) => {
  if (region === "west") return code !== ruRU;
  if (region === "east") return code !== nlNL;
  return true;
});

export const languagesList = Object.fromEntries(filteredLanguages) as Partial<Record<LanguageCode, Language>>;

export const languages = (type: LanguageCode = enUS): Language => {
  return languagesList[type] ?? allLanguages[enUS]; 
};

export const parseUserLanguage = (settings: string[], short = false): Language | string => {
    const langSetting = settings.find(s => s.startsWith('lang_'));
    const langCode: LanguageCode = languageParse(langSetting ?? 'lang_en');
    if(short){
        return allLanguages[langCode].short;
    }
    return allLanguages[langCode];
};


export const useMobileView = () => {
  return useMediaQuery({ query: '(max-width: 967px)' });
};

export const setToken = (token: string): void => {
    setItemParam(authToken,token)
    setEvent(authToken,token)
};

export const setCourseView = (status: string): void => {
    setItemParam(courseView,status)
    setEvent(courseView,status)
}

export function setLanguage(language: string) {
  if (localStorage.getItem("language") === language) return; // prevent infinite loop
  setItemParam(systemLanguage,language)
  setEvent(systemLanguage,language)
}


export const setOrganization = (data: string): void => {
    setItemParam(organization,data)
}

export const setOrganizations = (data: string): void => {
    setItemParam(organizations,data)
}

export const setOrganizationCount = (count: number): void => {
    setItemParam(organizationCount, count)
}

export const setUserCount = (count: number): void => {
    setItemParam(userCount, count)
}

export const setActiveOrganization = (id: number): void => {
    setItemParam(activeOrganization, id)
    setEvent(activeOrganization, id.toString())
}

export const setAppVersion = (data: string): void => {
    setItemParam(appVersion,data);
}

export const setMenuOpened = (status: string): void => {
    setItemParam(menuOpen,status)
    setEvent(menuOpen,status)
}

export const setUserActivityData = (activity: string): void => {
    setItemParam(userActivity,activity)
}

export const setPhishingData = (activity: string): void => {
    setItemParam(userPhishing,activity)
}

export const setMenuLabels = (labels: string): void => {
    setItemParam(menuLabels,labels)
}

export const setSystemLabels = (labels: string): void => {
    setItemParam(systemLabels,labels)
}

export const setUuid = (token: string): void => {
    setItemParam(uuidToken,token)
}

export const setUserLevel = (level: number): void => {
    setItemParam(userLevel,level)
}

export const setUserPoints = (points: number): void => {
    setItemParam(userPoints,points)
}

export const setUserName = (firstname: string, lastname: string): void => {
    setItemParam(userFullName, firstname + ' ' + lastname)
}

export const setUserContData = (data: string): void => {
    setItemParam(userContData,data)
}

export const setUserChapters = (data: string): void => {
    setItemParam(userChapters, data)
}

export const getToken = (): string => {
    return getItemParam(authToken) as string;
}

export const getAppVersion = (): string => {
    return getItemParam(appVersion) as string;
}

export const getCourseView = (): string => {
    return getItemParam(courseView) as string;
}

export const getOrganization = (): Organization => {
  const raw = getItemParam(organization);
  return JSON.parse(raw as string) as Organization;
};

export const getOrganizations = (): Organizations => {
    const raw = getItemParam(organizations);
    return JSON.parse(raw as string) as Organizations
}

export const getOrganizationsCount = (): number => {
    const count = getItemParam(organizationCount);
    return Number(count) || 0;
};

export const getUserCount = (): number => {
    const count = getItemParam(userCount);
    return Number(count) || 0;
};




export const getActiveOrganization = (): Organization | undefined => {
    const orgList = getOrganizations(); 
    const activeId = getItemParam(activeOrganization); 

    return orgList.find(org => org.id === Number(activeId));
}


export const getUserActivity = (): string => {
    let userActivityList = getItemParam(userActivity);
    if(!userActivityList){
        return JSON.stringify([]) as string
    }
    return getItemParam(userActivity) as string;
}

export const getPhishingData = (): string => {
    return getItemParam(userPhishing) as string;
}

export const getMenuOpened = (): string => {
    return getItemParam(menuOpen) as string;
}

export const getLanguage = (): string => {
    return getItemParam(systemLanguage) as string;
}

export const getLanguageShortname = (): string => {
    return JSON.parse(getLanguage()).short as string;
}

export const getLanguageArray = (): Language => {
  try {
    const lang = getLanguage(); 
    if (!lang) throw new Error('No language set');
    const parsed = JSON.parse(lang) as Language;
    if (!parsed?.short || !parsed?.name || !parsed?.flag) {
      throw new Error('Invalid language data');
    }
    return parsed;
  } catch {
    const fallback = allLanguages[enUS];
    setLanguage(JSON.stringify(fallback));
    return fallback;
  }
};

export const getUuid = (): string => {
    return getItemParam(uuidToken) as string;
}

export const getUserLevel = (): number => {
    return getItemParam(userLevel, 1) as number;
}

export const getUserPoints = (): number => {
    return getItemParam(userPoints, 1) as number;
}

export const getUserFullName = (): string => {
    return getItemParam(userFullName, 'No Name') as string;
}

export const getUserFirstName = (): string => {
    const fullname = getUserFullName()
    const [firstName] = fullname.trim().split(" ")
    return firstName
}

export const getMenuLabels = (): string => {
    return getItemParam(menuLabels) as string
}

export const getSystemLabels = (): string | null => {
    return getItemParam(systemLabels) as string | null;
};

export const getSystemLabelsArray = (): Record<string, any> => {
    const item = getSystemLabels();
    if (!item) return {}; 
    try {
        return JSON.parse(item);
    } catch (e) {
        console.error("Failed to parse systemLabels from localStorage", e);
        return {};
    }
};

export const getLabel = (labelKey: string, sessionLang: unknown): string => {
    const lang = ((sessionLang as unknown) as Language).short || 'EN';
    const sessionLabels = getSystemLabelsArray();
    const value = sessionLabels?.[labelKey]?.[lang];
    if (value) return value;
    return ''
};


export const getUserContData = (): ContributionData[] => {
    const raw = getItemParam(userContData); 
    if (typeof raw !== 'string') return []; 
    try {
      const parsed: any[] = JSON.parse(raw); 
      return parsed.map((entry) => {
        const dateKey = Object.keys(entry)[0]; 
        const levelData = entry[dateKey];
        return {
          [dateKey]: levelData, 
        };
      });
    } catch (e) {
      console.error('Error parsing contribution data from localStorage:', e);
      //signOutService()
      return [];
    }
};

export const getUserContYears = () => { 
  const data = getUserContData();
  return Array.from(new Set(data.map(item => Object.keys(item)[0].slice(0, 4))))
    .sort((a, b) => Number(b) - Number(a));
};

export const getUserChaptersData = (): Chapter[] => {
    try {
        const chapters = String(getItemParam(userChapters));
        return JSON.parse(chapters) as Chapter[];
    }catch (e){
        //signOutService()
        return []
    }
};

export const getUserPhishingSummary = () => {
  try {
    const phishing = String(getItemParam(userPhishing));
    const data = JSON.parse(phishing) as {
      correct_attempts: number;
      failed_attempts: number;
      total_attempts: number;
    };

    const { correct_attempts, failed_attempts, total_attempts } = data;

    return {
      correct_attempts: Number(correct_attempts) || 0,
      correct_percentage:
        total_attempts > 0
          ? (Number(correct_attempts) / Number(total_attempts)) * 100
          : 0,
      failed_attempts: Number(failed_attempts) || 0,
      failed_percentage:
        total_attempts > 0
          ? (Number(failed_attempts) / Number(total_attempts)) * 100
          : 0,
        total_attempts: total_attempts
    };
  } catch (e) {
    signOutService();
    return {
      correct_attempts: 0,
      correct_percentage: 0,
      failed_attempts: 0,
      failed_percentage: 0,
      total_attempts: 0
    };
  }
};


export const removeToken = (): void => {
    removeItemParam(authToken);
};

export const removeUuid = (): void => {
    removeItemParam(uuidToken);
};

export const removeActivity = (): void => {
    removeItemParam(userContData);
};

export const removeChapters = (): void => {
    removeItemParam(userChapters);
};

export const generatePointsArray = (maxLevel: number, increment: number): Point[] => {
    const points: Point[] = []; 
    for (let level = 1; level <= maxLevel; level++) {
        points.push({ max: level * increment, level });
    }
    return points; 
};

export const shortname = (fullName: string): string => {
  const nameParts = fullName.split(' ');
  const initials = nameParts.map(name => name.charAt(0).toUpperCase()).join('');
  return initials;
};

export const checkRequiredParams = () => {
    const requiredParams = [
        userFullName, authToken, uuidToken,
        menuLabels, systemLabels, appVersion,
        organizations, organizationCount, userCount
    ]
    return requiredParams.every(param => {
        const value = localStorage.getItem(param);
        return value !== null && value.trim() !== "";
    });
}

export const signOutService = () => {
    removeActivity()
    removeChapters()
    setMenuOpened("false")
    setCourseView("false")
    const removeParams = [
        userFullName, userLevel, userPoints, 
        authToken, uuidToken, userActivity, 
        organizations, organizationCount, userCount
    ]
    removeParams.map((param) => {
        removeItemParam(param)
    })
}

export const checkToken = async (token: string, uuidToken: string) => {
    try {

        const response = await gql({
          query: `
            mutation CheckAuth {
                checkAuth(
                    authInput: {
                        uuid: "${uuidToken}"
                        token: "${token}"
                        user_uuid: "${uuidToken}"
                    }
                ) {
                    uuid
                    token
                    refresh
                }
            }
          `, 
          returnFunc: 'checkAuth'
        });

        return response;

    } catch (error) {}
}


export const getLatestMonthData = (data: ActivityData, all: boolean = false) => {
    const years = Object.keys(data).map(Number).sort((a, b) => b - a);
  
    if (all) {
      const allMonths: { year: number; month: number; activities: MonthData }[] = [];
      for (const year of years) {
        const months = Object.keys(data[year]).map(Number).sort((a, b) => b - a);
        for (const month of months) {
          allMonths.push({
            year,
            month,
            activities: data[year][month],
          });
        }
      }
  
      return allMonths;
    }
  
    for (const year of years) {
      const months = Object.keys(data[year]).map(Number).sort((a, b) => b - a);
      if (months.length > 0) {
        const latestMonth = months[0];
        return {
          year,
          month: latestMonth,
          activities: data[year][latestMonth],
        };
      }
    }
  
    return null;
};

export const getItemsPerPage = () => {
   return Number(process.env.REACT_APP_LOG_ITEMS_PER_PAGE) || 10;
} 
  
  
export const monthNames = [
    "", "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];


const setItemParam = (label: string, data: any): void => {
    localStorage.setItem(label,data);
}

const getItemParam = (label: string, defaultValue: string | number = ""): string | number => {
    let item = localStorage.getItem(label);
    if (item === null) {
        const value = typeof defaultValue === "number" ? defaultValue.toString() : defaultValue;
        localStorage.setItem(label, value);
        return defaultValue;
    }
    if (typeof defaultValue === "number") {
        const parsedValue = parseInt(item, 10);
        return isNaN(parsedValue) ? defaultValue : parsedValue;
    }
    return item;
};

const removeItemParam = (label: string) => {
    return localStorage.removeItem(label)
}

const setEvent = (key: string, value: string) => {
    window.dispatchEvent(new StorageEvent('storage', {
        key: key,
        newValue: value
    }));
}
